import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { CellTower } from "@phosphor-icons/react";
import { renderToString } from "react-dom/server";

interface TowerMarkerProps {
  position: [number, number];
  popupContent?: React.ReactNode;
}

export const TowerMarker: React.FC<TowerMarkerProps> = ({ position, popupContent }) => {
  const iconHtml = renderToString(<CellTower size={28} weight="bold" color="#0d00ff" />);

  const customIcon = L.divIcon({
    html: iconHtml,
    className: "custom-phosphor-icon",
    iconSize: [32, 32],
    iconAnchor: [16, 32], // Anchor point is at the bottom center of the icon
    popupAnchor: [0, -32], // Popup appears above the icon
  });

  return (
    <Marker position={position} icon={customIcon}>
      {popupContent && <Popup>{popupContent}</Popup>}
    </Marker>
  );
};
